<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Dettaglio parente #' + this.$route.params.id : 'Nuovo parente')">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio)">
                        <b-row class="my-1">
                            <b-col sm="3"><label for="titolo">Nominativo socio:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="parente.nomesocio" id="nomesocio" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="note">Nome:</label></b-col>
                            <b-col sm="9">
                                 <b-form-input v-model="parente.nome" id="parente" type="text"></b-form-input>
                            </b-col>
                        </b-row>   
                        <b-row class="my-1">
                            <b-col sm="3"><label for="note">Codice fiscale:</label></b-col>
                            <b-col sm="9">
                                 <b-form-input v-model="parente.codfiscale" id="codfiscale" type="text" maxlength="16"></b-form-input>
                            </b-col>
                        </b-row>  
                        <b-row class="my-1">
                            <b-col sm="3"><label for="tipo">Tipo:</label></b-col>
                            <b-col sm="9">
                                 <b-form-input v-model="parente.tipo" id="tipo" type="text"></b-form-input>
                            </b-col>
                        </b-row>   
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flgatt">Attivo:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="parente.flgatt" :options="options_attivo" id="flgatt">

                                </b-form-select>
                            </b-col>
                        </b-row>                                                                                         
                        <b-row class="my-1" v-if="parente.id != null">
                            <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="parente.datains" id="datains" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>                                
                        <b-row class="my-1" v-if="parente.id != null">
                            <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="parente.uteins" id="uteins" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>    
                        <b-row class="my-3">
                            <b-col sm="6" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="parente.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>                                    
                        </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>

import {
    NAMESPACE,
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {
            
            namespace: NAMESPACE,
            parente: {
                id: this.$route.params.id || null,        
                id_socio: this.$route.params.id_socio,        
                nomesocio: '',
                nome: '',
                tipo: '',
                codfiscale: '',
                datains: null,
                uteins: '',
                flgatt: 'S',
            },     
            options_attivo: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],                               
            error: '',
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0,                 
        };
    },
    watch: {
        'parente.codfiscale': function(val, oldVal) {
            if (val != null) {
                this.parente.codfiscale = val.toUpperCase();
            }
        },
    },
    methods: {                
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },

        insert() {

            if (this.parente.nome == '') {
                this.showerror = true;
                this.error = "Campo nome vuoto!";       
            } 
            else if (this.parente.tipo == '') {
                this.showerror = true;
                this.error = "Campo tipo vuoto!";
            }              
            else if (this.parente.codfiscale != '' && this.parente.codfiscale.length != 16) {
                this.showerror = true;
                this.error = "Campo codice fiscale deve essere composto da 16 caratteri!";
            }
            else {
                
                var json = JSON.stringify(this.parente);

                var appdettaglio = this;

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/parente', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.parente = res[0];
                                    this.showerror = false;
                                    this.showdettaglio = true; //anche se non dovrebbe servire                                 
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/dettaglioparente/' + this.parente.id);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

        }
    },
    created: function () {

        if(!ctrlVismenu("S")){
            this.$router.replace('/accessdenied');
            return;
        }

        var id = this.parente.id; //se è la prima volta si prova a prendere da getid 
        var token = localStorage.getItem('token');

        var appdettaglio = this;
        if (id != null) {                        

            this.axios.get(NAMESPACE + 'rest/dettaglioparente/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                appdettaglio.parente = res[0];
                                appdettaglio.showdettaglio = true;


                            } else {
                                throw new Error("Errore dati non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }
        else{             

            this.axios.get(NAMESPACE + 'rest/soci/' + this.parente.id_socio, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                this.parente.nomesocio = res[0].nome + ' ' + res[0].cognome;
                                appdettaglio.showdettaglio = true;

                            } else {
                                throw new Error("Errore dati non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });
        }

    },
    mounted: function() { 
        
    }

}
</script>
